import { use } from 'react';
import { DisputeDetailClient } from './dispute-detail-client';

export const metadata = { title: 'Dispute · Admin' };

export default function Page({ params }: { params: Promise<{ id: string }> }) {
  const { id } = use(params);
  return <DisputeDetailClient purchaseId={id} />;
}
